import { Controller } from "@hotwired/stimulus"
import { dsConfirm } from "../../utils/ds_confirm";

// Connects to data-controller="suppliers"
export default class extends Controller {
  static targets = ["deleteButton", "modalContainer"]

  connect() {
    console.log("Suppliers controller connected")
  }

  openModal(event) {
    event.preventDefault()
    const url = event.currentTarget.getAttribute("href")
    
    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      // Update the modal content with the response
      Turbo.renderStreamMessage(html)
      
      // Find the modal controller and open it
      const modalElement = document.getElementById("supplier-modal")
      if (modalElement) {
        const modalController = this.application.getControllerForElementAndIdentifier(
          modalElement, 
          "modal"
        )
        
        if (modalController) {
          modalController.open()
        }
      }
    })
  }
  
  openLocalModal(event) {
    event.preventDefault()
    const modalId = event.currentTarget.dataset.modalId
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")

      // Add listeners to close buttons
      const closeButtons = modal.querySelectorAll('[data-action*="modal#close"]')
      closeButtons.forEach(btn => {
        if (!btn.dataset.localCloseHandlerSet) {
          btn.addEventListener('click', (e) => {
            e.preventDefault()
            modal.classList.add("hidden")
            document.body.classList.remove("overflow-hidden")
          })
          btn.dataset.localCloseHandlerSet = "true"
        }
      })
    }
  }

  async confirmDelete(event) {
    event.preventDefault()

    const button = event.currentTarget
    const message = button.dataset.suppliersConfirmMessage || "Are you sure you want to delete this supplier?"

    if (await dsConfirm(message, { tone: "danger" })) {
      const url = button.getAttribute("data-url")
      fetch(url, {
        method: "DELETE",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
    }
  }
} 